<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3 bg-light">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/meeting">Meeting</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Vedi il meeting
          </li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>

    <LoadedComponent :loading="loading" />
    <div class="page-content" v-if="!loading">
      <div class="container">
        <div class="row">
          <div class="col-lg-9">
            <article class="entry">
              <div class="entry-body">
                <h2 class="entry-title">
                  <span>{{ meeting.name }}</span>
                </h2>
                <!-- End .entry-title -->
                <div class="entry-content">
                  <p>{{ meeting.description }}</p>
                </div>
              </div>

              <figure class="entry-media">
                <video-component :options="optionsVideo"></video-component>
              </figure>

              <div class="entry-body">
                <div class="entry-meta">
                  <span class="entry-author">
                    by <span>{{ meeting.author }}</span>
                  </span>
                  <span class="meta-separator">|</span>
                  <span>{{ meeting.datetime_start }}</span>
                  <span class="meta-separator">|</span>
                  <span>{{ comments.length }} commenti</span>
                </div>
                <!-- End .entry-meta -->

                <br />
                <button type="button" class="btn btn-danger text-light" data-toggle="modal"
                  data-target="#confirm-delete" v-if="meeting.owner">
                  Elimina il meeting
                </button>
              </div>
              <!-- End .entry-body -->
            </article>
          </div>

          <aside class="col-lg-3">
            <div class="sidebar">
              <div class="widget widget-search">
                <h3 class="widget-title">Commenti</h3>
                <!-- End .widget-title -->
                <CommentListComponent :activity_id="meeting.activity_id" :successmessagecomment="successMessageComment"
                  @setSuccessMessage="setSuccessMessage" :comments="comments" :loadComments="loadComments"
                  :comment_permission="comment_permission" :model="'meeting-old'" class="mt-4"></CommentListComponent>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="confirm-delete">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Conferma eliminazione</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-meeting">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <p>Sei sicuro di voler eliminare e annullare il meeting?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              Annulla
            </button>
            <button type="button" class="btn btn-outline-danger" @click="deleteMeeting">
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import httpservices from "@/services/httpservices.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import VideoComponent from "@/components/VideoComponent.vue";
import CommentListComponent from "@/components/CommentList.vue";
export default {
  name: "ShowOldMeeting",
  components: { LoadedComponent, VideoComponent, CommentListComponent },
  props: ["slug"],
  data() {
    return {
      meeting: {},
      loading: true,
      optionsVideo: {},
      comments: [],
    };
  },
  mounted() {
    this.loadMeeting();
  },
  created() { },
  methods: {
    async loadPermission() {
      await httpservices
        .checkPermission(0, "comments", "create_comment")
        .then((response) => {
          this.comment_permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
      await httpservices
        .checkPermission(1, "meeting", "")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateComments(newComments) {
      // Emit an event to update the prop value outside the component
      this.$emit("update:comments", newComments);
    },
    setSuccessMessage(value) {
      this.successMessageComment = value;
    },
    setErrorMessage(value) {
      this.errorMessageComment = value;
    },
    async loadComments() {
      try
      {
        const response = await httpservices.loadComments(
          this.meeting.activity_id
        );
        this.comments = response.data.data;
        this.loading = false;
      } catch (error)
      {
        console.log(error);
      }
    },
    async loadMeeting() {
      await httpauth
        .get("/meetings/show/" + this.slug)
        .then((response) => {
          this.meeting = response.data.data;
          if (this.meeting.video != null)
          {
            this.optionsVideo = this.getOptons(this.meeting.video.path);
          }

          this.loadComments();
          this.loading = false;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async deleteMeeting() {
      await httpauth
        .delete("/meetings/" + this.meeting.slug)
        .then((response) => {
          if (response.data.status == 1)
          {
            localStorage.setItem(
              "messageSuccessMeeting",
              response.data.message
            );
            location.href = "/meeting";
            return;
          }
          localStorage.setItem("messageErrorMeeting", response.data.message);
          location.href = "/meeting";
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    getOptons(path) {
      return {
        controls: true,
        autoplay: true,
        fluid: true,
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
  },
};
</script>